import http from './http';

export const imageApi = {
  upload: (file: File) => {
    const formData = new FormData();
    formData.append('image', file);
    return http.post('/images/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);
  }
};
